// In production on Hostinger, the React build lives in public_html/
// and the API lives in public_html/api/ — same domain, no CORS issues.
// In local dev, set REACT_APP_API_URL=http://localhost:8000 (php -S localhost:8000 -t api/)
const BASE = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}`
  : `${window.location.origin}/api`;

async function request(url, options = {}) {
  const res = await fetch(url, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    credentials: 'include',
    ...options,
    body: options.body !== undefined ? JSON.stringify(options.body) : undefined,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}

export const api = {
  // Employees & locations
  getEmployees:   ()     => request(`${BASE}/employees.php`),
  createEmployee: (body) => request(`${BASE}/employees.php`, { method: 'POST', body }),
  getLocations:   ()     => request(`${BASE}/employees.php?action=locations`),
  createLocation: (body) => request(`${BASE}/employees.php?action=location`, { method: 'POST', body }),

  // WebAuthn registration
  registerOptions: (employeeId) => request(`${BASE}/webauthn_register.php?action=options`, { method: 'POST', body: { employeeId } }),
  registerVerify:  (body)       => request(`${BASE}/webauthn_register.php?action=verify`,  { method: 'POST', body }),

  // WebAuthn authentication
  authOptions: (employeeId) => request(`${BASE}/webauthn_auth.php?action=options`, { method: 'POST', body: { employeeId } }),
  authVerify:  (body)       => request(`${BASE}/webauthn_auth.php?action=verify`,  { method: 'POST', body }),

  // Attendance
  checkIn:        (body)   => request(`${BASE}/attendance.php?action=checkin`, { method: 'POST', body }),
  getLogs:        (params) => request(`${BASE}/attendance.php?action=logs&${new URLSearchParams(params)}`),
  getTodaySummary:()       => request(`${BASE}/attendance.php?action=summary`),
};
